import { navigate } from 'gatsby'
import OrgHomePage from 'components/Organization/HomePage'
import useQueryString from 'utils/useQueryString'
import { useAppSelector } from 'store/hooks'
import React, { ReactElement, useLayoutEffect } from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import { CONTROLDText } from 'ui/CONTROLD'
import { useLocation } from '@reach/router'
import structuredDataSchema from 'seo/structuredDataSchema.json'

const HomePageWrapper = (): ReactElement | null => {
  const { qs } = useQueryString()
  const isLoggedIn = useAppSelector(s => s.session.sessionToken)
  const location = useLocation()
  useLayoutEffect(() => {
    // Logged in users should be redirected from the homepage to the dashboard
    if (isLoggedIn && !qs.noRedirect && location.hash === '') {
      navigate('/dashboard/profiles')
    }
  }, [isLoggedIn, location.hash, qs.noRedirect])

  return isLoggedIn && !qs.noRedirect && location.hash === '' ? null : <OrgHomePage />
}
export default HomePageWrapper

export const Head = getDocumentHead({
  title: `Advanced DNS Filtering for Businesses & Consumers | ${CONTROLDText}`,
  shouldAugmentTitle: false,
  description: `Control D is a scalable DNS filtering service that blocks malicious threats, unwanted content, trackers, and ads - on all devices.`,
  children: (
    <script type="application/ld+json">{JSON.stringify(structuredDataSchema, null, 2)}</script>
  ),
})
